import React from "react";
import styled from "styled-components";
import {
  dateFormatNumber,
  formatPercentage,
  getCoinCodeImage,
} from "../../../utils/helper";
import { useApp } from "../../../contexts";
import { CopyIcon } from "../../../components/Icons/CopyIcon";
import { Copy } from "../../../components/Copy";
import moment from "moment";
import { Tooltip } from "antd";
import { InfoTooltipIcon } from "../../../pages/Home/styles";
import { useWindowSize } from "../../../hook/useWindowSize";
import NumberFormat from "react-number-format";
import { STAKE_SUB_TAB } from "./TableStake";
import { roundNumber } from "../../../services/app";

const Wraper = styled.div`
  border-top: 1px solid #f2efef;
  &:first-child {
    border-top: unset;
  }
`;

export const WalletRowStake = ({ viewType, onClick, className, item }) => {
  const { T } = useApp();
  const size = useWindowSize();
  const isIneligible =
    !moment(new Date()).isAfter(new Date(item.validStakeTimeFrom)) &&
    moment(new Date()).isBefore(new Date(item.validStakeTimeTo));

  const renderActiveStakingBalances = () => {
    return (
      <>
        <div className="flex flex-wrap items-center">
          <div className="flex justify-between items-center w-full">
            <span className="text-[16px] text-black font-semibold font-inter">
              {`${T("Staked")} ${item.amount} ${item.tokenName}`}
            </span>
            <span className="text-[16px] text-black font-semibold font-inter text-right capitalize">
              {item.duration === 1
                ? T(`{year} Year`).replace("{year}", 1)
                : T(`{year} Years`).replace("{year}", item.duration)}
            </span>
          </div>

          <div className="flex justify-between items-center mt-[2px] w-full">
            <span className="text-[#F12E11] font-[600] text-[12px]">
              {`${T("Earn")} ${+item.interestRate * item.amount} SGT`}
            </span>
            <span className="font-[600] text-[12px]">
              {`${formatPercentage(item.interestRate, 0)} ${T("Interest")}`}
            </span>
          </div>

          <div className="flex flex-col w-full mt-[3px]">
            <div className="flex justify-between items-center w-full">
              <span className="text-[10px]/[12px] text-[#8C8D99] font-inter">
                {T("Start at {date}").replace(
                  "{date}",
                  `${dateFormatNumber(item.startTime, "YYYY/MM/DD")}`
                )}
              </span>
              <span className="text-[10px]/[12px] text-black text-right">
                <Copy
                  textStyle={{ fontWeight: 400, fontSize: 10 }}
                  cutText={true}
                  splitFont={5}
                  splitFontLg={5}
                  numDot={3}
                  text={item.txHash}
                  icon={<CopyIcon />}
                />
              </span>
            </div>
            <div className="flex justify-between items-start w-full">
              <span className="text-[10px]/[12px] text-[#8C8D99] font-inter">
                {T("End at {date}").replace(
                  "{date}",
                  `${dateFormatNumber(item.claimTime, "YYYY/MM/DD")}`
                )}
              </span>
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderEligibleStakingBalances = () => {
    const exercisePercentage = roundNumber(
      (item.stakedAmount / item.exercisedAmount) * 100,
      0
    );

    return (
      <>
        <div className="flex flex-nowrap items-start justify-between">
          <div className="flex flex-col gap-1">
            <div className="text-[15px] text-black font-semibold flex font-inter">
              <img
                alt=""
                style={{ width: 20, height: 20 }}
                src={`/assets/images/otc/crypto/${getCoinCodeImage(
                  item.name
                )?.toLowerCase()}.svg`}
              />
              <span style={{ marginLeft: 4 }}>{item.name}</span>
            </div>
            <span className="text-[10px] text-[#8C8D99] font-inter">
              {T("Start at {date}").replace(
                "{date}",
                `${dateFormatNumber(item.validStakeTimeFrom, "YYYY/MM/DD")}`
              )}
            </span>
            <span className="text-[10px] text-[#8C8D99] font-inter">
              {T("End at {date}").replace(
                "{date}",
                `${dateFormatNumber(item.validStakeTimeTo, "YYYY/MM/DD")}`
              )}
            </span>
          </div>
          <div className="flex flex-col items-end">
            <span className="text-[10px] text-[#8C8D99]">{T("Staking")}</span>
            <span className="text-[16px] whitespace-nowrap font-semibold">
              <NumberFormat
                value={item.stakedAmount}
                displayType={"text"}
                thousandSeparator={true}
                suffix={` ${item.stakeCurrency || "SGT"}`}
                decimalScale={3}
              />
            </span>
            {moment(new Date()).isBefore(new Date(item.validStakeTimeFrom)) ? (
              <span className="text-xs text-black whitespace-nowrap">
                {T("Incoming")}
              </span>
            ) : (
              <>
                {moment(new Date()).isAfter(
                  new Date(item.validStakeTimeFrom)
                ) &&
                moment(new Date()).isBefore(new Date(item.validStakeTimeTo)) ? (
                  <>
                    {item.remainAmount === 0 ? (
                      <span className="text-xs text-black whitespace-nowrap">
                        {T("Fully Stake")}
                      </span>
                    ) : (
                      <></>
                    )}
                    {item.remainAmount > 0 ? (
                      <span className="text-xs text-[#0F8ACB]  whitespace-nowrap">
                        {T("Eligible")}
                      </span>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <>
                    {item.remainAmount === 0 ? (
                      <span className="text-xs text-black whitespace-nowrap">
                        {T("Fully Stake")}
                      </span>
                    ) : (
                      <span className="text-xs text-[#E6665C] whitespace-nowrap">
                        {T("Ineligible")}
                      </span>
                    )}
                  </>
                )}
              </>
            )}
          </div>
        </div>
        <div className="mt-[10px]">
          <div className="flex items-center justify-between">
            <div className="text-black text-[10px] font-medium">
              {item.name === "SGT"
                ? T("Walking_reward") + ` ${item.description}`
                : ""}
              {item.name === "SOTa"
                ? T("Released") + ` ${item.description}`
                : ""}
            </div>
            <div className="flex items-center justify-end">
              <Tooltip
                trigger={size.width < 768 ? "click" : "hover"}
                onClick={(e) => e.stopPropagation()}
                className="cursor-pointer mx-[5px]"
                color={"#EAF2FF"}
                overlayClassName={"note-tooltip-10"}
                title={
                  <div>
                    <div>
                      {T(
                        "The remaining amount represents the eligible quantity that can be staked in the option."
                      )}
                    </div>
                    <div>{T("This value is determined based on:")}</div>
                    <ul className="list-disc pl-6">
                      <li>{T("User's exercised tokens")}</li>
                      <li>{T("The tokens currently staked")}</li>
                      <li>
                        {T(
                          "The amount that falls within the eligible staking period for that specific token."
                        )}
                      </li>
                    </ul>
                  </div>
                }
              >
                <span>
                  <InfoTooltipIcon className="w-[12px]" />
                </span>
              </Tooltip>
              <span className="text-[#8C8D99] text-[10px]">
                {T("Remain: {amount}").replace(
                  "{amount}",
                  `${isIneligible ? 0 : item.remainAmount}/${
                    item.exercisedAmount
                  } ${item.stakeCurrency || "SGT"}`
                )}
              </span>
            </div>
          </div>
        </div>
        <div className="flex w-full mt-1">
          <div className="w-full bg-black/20 h-[5px] rounded-full">
            <div
              className={`bg-[#F12E11] opacity-100 h-[5px] rounded-full`}
              style={{
                width: `${exercisePercentage ? `${exercisePercentage}%` : 0}`,
              }}
            ></div>
          </div>
        </div>
      </>
    );
  };

  const renderStakingHistory = () => {
    return (
      <>
        <div className="flex flex-wrap items-center gap-x-3">
          <div className="flex justify-between items-center  w-full">
            <span className="text-[16px] text-black font-semibold font-inter">
              {`${T("Staked")} ${item.amount} ${item.tokenName}`}
            </span>
            <span className="text-[16px] text-black font-semibold font-inter text-right capitalize">
              {item.duration === 1
                ? T(`{year} Year`).replace("{year}", 1)
                : T(`{year} Years`).replace("{year}", item.duration)}
            </span>
          </div>
          <div className="flex justify-between items-center mt-[5px] w-full">
            <span className="text-[10px] text-[#8C8D99] font-inter">
              {T("Start at {date}").replace(
                "{date}",
                `${dateFormatNumber(item.startTime, "YYYY/MM/DD")}`
              )}
            </span>
            <span className="text-[10px] text-black text-right">
              <Copy
                textStyle={{ fontWeight: 400, fontSize: 10 }}
                cutText={true}
                splitFont={5}
                splitFontLg={5}
                numDot={3}
                text={item.txHash}
                icon={<CopyIcon />}
              />
            </span>
          </div>
          <div className="flex justify-between items-start mt-[5px] w-full">
            <span className="text-[10px] text-[#8C8D99] font-inter">
              {T("End at {date}").replace(
                "{date}",
                `${dateFormatNumber(item.claimTime, "YYYY/MM/DD")}`
              )}
            </span>
            <span className="text-[10px] font-semibold text-right">
              {item.status === 0 && (
                <span className="stake-status-pending">{T("Pending")}</span>
              )}
              {item.status === 1 && (
                <span className="stake-status-success">{T("Success")}</span>
              )}
              {item.status === 2 && (
                <span className="stake-status-failed">{T("Stake Failed")}</span>
              )}
              {item.status === 3 && (
                <span className="stake-status-holding">{T("Holding")}</span>
              )}
            </span>
          </div>
        </div>
      </>
    );
  };

  const renderMobileItems = () => {
    switch (viewType) {
      case STAKE_SUB_TAB.ACTIVE:
        return renderActiveStakingBalances();
      case STAKE_SUB_TAB.ELIGIBLE:
        return renderEligibleStakingBalances();
      case STAKE_SUB_TAB.HISTORY:
        return renderStakingHistory();
      default:
        return <></>;
    }
  };

  return (
    <Wraper
      className={`flex justify-between flex-col ${className}`}
      onClick={() => onClick?.()}
    >
      {renderMobileItems()}
    </Wraper>
  );
};
